import React from 'react';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { PosPlugin } from 'plugins/plugin';
import { reactcursively } from 'utils/react';
import { getCurrentPosLanguage } from 'reducers/configs/settings';
import { getSelectedCustomer } from 'reducers/customerSearch';

import logoEn from './journie_logo_en.png';
import logoFr from './journie_logo_fr.png';

const WithJournieLogo: PosPlugin['UIUserBadge'] = ({ children }) => {
  const { t } = useTranslation('journieMember');
  const language = useSelector(getCurrentPosLanguage);
  const customer = useSelector(getSelectedCustomer);

  if (
    typeof customer.referenceNumber !== 'string' ||
    !customer.referenceNumber?.length
  ) {
    return children;
  }

  return reactcursively(
    R.when(
      R.pathEq(['props', 'id'], 'user-icon'),
      R.assocPath(
        ['props', 'children'],
        <div
          className="user-badge-icon"
          style={{ borderRadius: 0, width: 'auto', height: 'auto' }}
        >
          <img
            src={language === 'fr' ? logoFr : logoEn}
            alt={t('title')}
            style={{
              width: 'auto',
              height: 'auto',
            }}
          />
        </div>,
      ),
    ),
  )(children);
};

export default WithJournieLogo;
